import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { servicesData } from '../../mocks/services';
import { testimonialsData } from '../../mocks/testimonials';
import { useState } from 'react';
import { useCart } from '../../context/CartContext';

export default function HomePage() {
  const [currentPage, setCurrentPage] = useState(0);
  const { addToCart } = useCart();

  const featuredServices = servicesData.slice(0, 3);
  
  // Testimonials pagination - 3 per page
  const testimonialsPerPage = 3;
  const totalPages = Math.ceil(testimonialsData.length / testimonialsPerPage);
  const currentTestimonials = testimonialsData.slice(
    currentPage * testimonialsPerPage,
    (currentPage + 1) * testimonialsPerPage
  );

  const handleAddToCart = (serviceId: string) => {
    const service = servicesData.find(s => s.id === serviceId);
    if (service) {
      addToCart(service);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden pt-20">
        <div className="absolute inset-0 bg-gradient-to-br from-cream via-white to-sand/30"></div>
        
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/f18e67251944660e2a4a540d67ead456/e65531115283625b5be55fb8328a7824.jpeg"
            alt="Bighorn Family Dental Reception"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary/70 via-primary/50 to-primary/30"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-8 w-full py-32">
          <div className="max-w-xl">
            <h1 className="font-serif text-6xl text-white mb-6 leading-tight">
              Welcome<br />
              Dental Clinic
            </h1>
            <p className="text-xl text-white/90 mb-10 leading-relaxed">
              Experience exceptional dental care in our modern, welcoming facility. Your smile is our priority.
            </p>
            <a
              href="tel:2296519254"
              className="inline-flex items-center px-8 py-4 bg-accent text-white rounded-full font-medium hover:bg-accent-dark transition-all cursor-pointer whitespace-nowrap shadow-lg"
            >
              Book Your Visit
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-24 px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-serif text-5xl text-navy mb-4">Our Services</h2>
          </div>

          <div className="grid grid-cols-3 gap-12" data-product-shop>
            {featuredServices.map((service, index) => {
              const icons = ['ri-stethoscope-line', 'ri-flask-line', 'ri-tooth-line'];
              const colors = ['text-primary', 'text-accent', 'text-primary'];
              return (
                <div
                  key={service.id}
                  className="text-center group cursor-pointer"
                >
                  <div className="mb-6 flex justify-center">
                    <div className="w-24 h-24 flex items-center justify-center">
                      <i className={`${icons[index % icons.length]} text-7xl ${colors[index % colors.length]} group-hover:scale-110 transition-transform`}></i>
                    </div>
                  </div>
                  <h3 className="font-serif text-2xl text-navy mb-4">{service.name}</h3>
                  <p className="text-navy/60 leading-relaxed mb-6 px-4">{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-24 px-8 bg-sand/30">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-serif text-5xl text-navy mb-4">Patient Testimonials</h2>
          </div>

          <div className="grid grid-cols-3 gap-8">
            {currentTestimonials.map((testimonial, index) => (
              <div key={testimonial.id} className="bg-white rounded-lg p-8 shadow-sm">
                <p className="text-navy/70 leading-relaxed mb-6 italic">
                  &ldquo;{testimonial.text}&rdquo;
                </p>
                <div className="font-medium text-navy">{testimonial.author}</div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <div className="flex items-center justify-center gap-2 mb-4">
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentPage(i)}
                  className={`w-3 h-3 rounded-full cursor-pointer transition-all hover:scale-125 ${
                    i === currentPage ? 'bg-primary' : 'bg-navy/20 hover:bg-navy/40'
                  }`}
                  aria-label={`Go to testimonials page ${i + 1}`}
                />
              ))}
            </div>
            <Link
              to="/about"
              className="inline-flex items-center px-8 py-3 border-2 border-primary text-primary rounded-full font-medium hover:bg-primary hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              Read more
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
